/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/condense': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 1.1l-4.3 4.3 2.7 2.7H8V1.6l2.7 2.7L14.9 0zM1.1 16l4.3-4.3 2.7 2.7V8H1.6l2.7 2.7L0 14.9z" _fill="#272c33"/>'
  }
})
